import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Round } from '../../../objects/round';
import { Router } from '@angular/router';
import { UtilityService } from 'src/app/services/utility.service';
import { Player } from 'src/app/objects/player';
import { PlayerService } from 'src/app/services/player.service';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 's18-display-round-list',
  templateUrl: './display-round-list.component.html',
  styleUrls: ['./display-round-list.component.scss']
})
export class DisplayRoundListComponent implements OnInit {
  @Input() rounds: any[];
  @Input() tRounds: boolean;
  @Input() usgaRound: boolean;
  @Input() adminView: boolean = false;
  @Output() refreshPlayers = new EventEmitter<any>();
  player : Player;

  constructor(
    private router: Router,
    private playerService : PlayerService,
    private utility: UtilityService,
    private snackbar : MatSnackBar
  ) { }

  ngOnInit() {
    this.player = this.playerService.getLoggedInPlayerInfo();
    if (this.player == null){
      this.router.navigateByUrl("/login");
    }
  }

  isHandicapRound(round: Round){
    if ( !this.tRounds){
      return +round.hcp_used === 1;
    }
    else{
      return (round.round_hcp - round.handicap < -3)
    }
  }

  delete(round){
    round.deleting = true;
    this.playerService.removeRound(round.usga_round_id, round.round_id)
      .subscribe(resp => {
        var response = JSON.parse(resp.d).response;
        if ( response === 'okay'){
          this.refreshPlayers.emit("go");
        }
        else{
          this.snackbar.open("Could not Remove round",null , { panelClass: 'warning-toast', duration: 5000, verticalPosition: 'top', horizontalPosition: 'center' });
        }
        round.deleting = false;
      }, err => {
        console.log(err);
        round.deleting = false;
      });
  }

  deleteBoth(round){
    round.deleting = true;
    this.playerService.removeBothRound(round.usga_round_id, round.round_id)
      .subscribe(resp => {
        var response = JSON.parse(resp.d).response;
        if ( response === 'okay'){
          this.refreshPlayers.emit("go");
        }
        else{
          this.snackbar.open("Could not Remove round",null , { panelClass: 'warning-toast', duration: 5000, verticalPosition: 'top', horizontalPosition: 'center' });
        }
        round.deleting = false;
      }, err => {
        console.log(err);
        round.deleting = false;
      });
  }


  modifyScore(){
    
  }

  isGroupAdmin(group_id){
    return this.playerService.isPlayerGroupAdmin(group_id) || this.player.player_id == 48;
  }

  goToStats(group_event_id){
    if (this.player.subscription_id && group_event_id>0){
      this.router.navigateByUrl("/event/stats/"+group_event_id);
    }
    else
    {
      this.snackbar.open("To post/see your stats, you need an active subscription and to have posted the event hole-by-hole through Golf GamesKeeper.", null, { duration: 3000});
    }
  }

  goToResults(group_event_id){
    if (+group_event_id > 0){
      this.router.navigateByUrl("/results/"+group_event_id);
    }
    else{
      this.snackbar.open("Round info not available.", null, { duration: 3000});
    }
  }

  postRoundsToUsga(){
    if (!this.player.subscription_id){
      //show dialog
      return;
    }
    //start doing shizzle
  }

}
